import { createAction, handleActions } from 'redux-actions'
import api from '../api'

export const GET_COUNTRIES = createAction('enums/GET_COUNTRIES')
export const GET_COUNTRIES_SUCCESS = createAction('enums/GET_COUNTRIES_SUCCESS')
export const GET_COUNTRIES_ERROR = createAction('enums/GET_COUNTRIES_ERROR')

export const GET_COUNTRY_CODES = createAction('enums/GET_COUNTRY_CODES')
export const GET_COUNTRY_CODES_SUCCESS = createAction('enums/GET_COUNTRY_CODES_SUCCESS')
export const GET_COUNTRY_CODES_ERROR = createAction('enums/GET_COUNTRY_CODES_ERROR')

export const GET_LANGUAGES = createAction('enums/GET_LANGUAGES')
export const GET_LANGUAGES_SUCCESS = createAction('enums/GET_LANGUAGES_SUCCESS')
export const GET_LANGUAGES_ERROR = createAction('enums/GET_LANGUAGES_ERROR')

export const GET_ROLES = createAction('enums/GET_ROLES')
export const GET_ROLES_SUCCESS = createAction('enums/GET_ROLES_SUCCESS')
export const GET_ROLES_ERROR = createAction('enums/GET_ROLES_ERROR')

export const GET_PAGE_NAMES = createAction('enums/GET_PAGE_NAMES')
export const GET_PAGE_NAMES_SUCCESS = createAction('enums/GET_PAGE_NAMES_SUCCESS')
export const GET_PAGE_NAMES_ERROR = createAction('enums/GET_PAGE_NAMES_ERROR')

const initialState = {
  loading: false,
  countries: [],
  countryCodes: [],
  languages: [],
  roles: [],
  pageNames: [],
  error: null
}

export default handleActions(
  {
    [GET_COUNTRIES]: (state, action) => ({
      ...state,
      loading: true
    }),
    [GET_COUNTRIES_SUCCESS]: (state, action) => ({
      ...state,
      loading: false,
      countries: action.payload
    }),
    [GET_COUNTRIES_ERROR]: (state, action) => ({
      ...state,
      loading: false,
      error: action.payload
    }),
    [GET_COUNTRY_CODES]: (state, action) => ({
      ...state,
      loading: true
    }),
    [GET_COUNTRY_CODES_SUCCESS]: (state, action) => ({
      ...state,
      loading: false,
      countryCodes: action.payload
    }),
    [GET_COUNTRY_CODES_ERROR]: (state, action) => ({
      ...state,
      loading: false,
      error: action.payload
    }),
    [GET_LANGUAGES]: (state, action) => ({
      ...state,
      loading: true
    }),
    [GET_LANGUAGES_SUCCESS]: (state, action) => ({
      ...state,
      loading: false,
      languages: action.payload
    }),
    [GET_LANGUAGES_ERROR]: (state, action) => ({
      ...state,
      loading: false,
      error: action.payload
    }),
    [GET_ROLES]: (state, action) => ({
      ...state,
      loading: true
    }),
    [GET_ROLES_SUCCESS]: (state, action) => ({
      ...state,
      loading: false,
      roles: action.payload
    }),
    [GET_ROLES_ERROR]: (state, action) => ({
      ...state,
      loading: false,
      error: action.payload
    }),
    [GET_PAGE_NAMES]: (state, action) => ({
      ...state,
      loading: true
    }),
    [GET_PAGE_NAMES_SUCCESS]: (state, action) => ({
      ...state,
      loading: false,
      pageNames: action.payload
    }),
    [GET_PAGE_NAMES_ERROR]: (state, action) => ({
      ...state,
      loading: false,
      error: action.payload
    })
  },
  initialState
)

export const getCountries = () => {
  return dispatch => {
    dispatch(GET_COUNTRIES())
    return api
      .get('enums/getcountries')
      .then(result => {
        dispatch(GET_COUNTRIES_SUCCESS(result))
      })
      .catch(error => {
        dispatch(GET_COUNTRIES_ERROR(error))
      })
  }
}

export const getCountryCodes = () => {
  return dispatch => {
    dispatch(GET_COUNTRY_CODES())
    return api
      .get('enums/getcountrycodes')
      .then(result => {
        dispatch(GET_COUNTRY_CODES_SUCCESS(result))
      })
      .catch(error => {
        dispatch(GET_COUNTRY_CODES_ERROR(error))
      })
  }
}

export const getLanguages = () => {
  return dispatch => {
    dispatch(GET_LANGUAGES())
    return api
      .get('enums/getlanguages')
      .then(result => {
        dispatch(GET_LANGUAGES_SUCCESS(result))
      })
      .catch(error => {
        dispatch(GET_LANGUAGES_ERROR(error))
      })
  }
}

export const getRoles = () => {
  return dispatch => {
    dispatch(GET_ROLES())
    return api
      .get('enums/getroles')
      .then(result => {
        dispatch(GET_ROLES_SUCCESS(result))
      })
      .catch(error => {
        dispatch(GET_ROLES_ERROR(error))
      })
  }
}

export const getPageNames = () => {
  return dispatch => {
    dispatch(GET_PAGE_NAMES())
    return api
      .get('enums/getpagenames')
      .then(result => {
        dispatch(GET_PAGE_NAMES_SUCCESS(result))
      })
      .catch(error => {
        dispatch(GET_PAGE_NAMES_ERROR(error))
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/enums/index.js